import * as React from 'react';
import type { SVGProps } from 'react';
const SvgViews = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            d="m21.977 14.783-2-9A1 1 0 0 0 19 5h-3v2h2.198l.961 4.326A4.5 4.5 0 0 0 17.5 11c-1.953 0-3.603 1.258-4.224 3h-2.553c-.621-1.742-2.271-3-4.224-3-.587 0-1.145.121-1.659.326L5.802 7H8V5H5a1 1 0 0 0-.976.783l-2 9 .047.011q-.063.35-.071.706C2 17.981 4.019 20 6.5 20c2.31 0 4.197-1.756 4.449-4h2.102c.252 2.244 2.139 4 4.449 4 2.481 0 4.5-2.019 4.5-4.5 0-.242-.034-.475-.071-.706zM6.5 18A2.503 2.503 0 0 1 4 15.5C4 14.122 5.122 13 6.5 13S9 14.122 9 15.5 7.878 18 6.5 18m11 0a2.503 2.503 0 0 1-2.5-2.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5"
        />
    </svg>
);
export default SvgViews;
